import React from 'react';
import PropTypes from 'prop-types';

import { useClassName } from 'common/hooks';

import { toOption } from 'common/helpers';

import './checkbox-cards.less';

const CheckboxCards = ({ name, items, selectedItems, setSelectedItems }) => {
  const classNames = useClassName('CheckboxCards');
  const options = (items || []).map(toOption);

  const toggle = (value) =>
    setSelectedItems(
      selectedItems.includes(value)
        ? selectedItems.filter((item) => item !== value)
        : [...selectedItems, value]
    );

  return (
    <div className={classNames('grid')}>
      {options.map(({ value, label, icon }) => {
        const checked = selectedItems.includes(value);

        return (
          <label
            key={value}
            className={classNames('card', checked ? 'checked' : '')}>
            <input
              type="checkbox"
              name={name}
              value={value}
              checked={checked}
              onChange={() => toggle(value)}
              className={classNames('input')}
            />
            <span className={classNames('box')} aria-hidden="true" />
            {icon && <img src={icon} alt="" className={classNames('icon')} />}
            <span className={classNames('label')}>{label}</span>
          </label>
        );
      })}
    </div>
  );
};

CheckboxCards.propTypes = {
  name: PropTypes.string,
  items: PropTypes.array,
  selectedItems: PropTypes.array.isRequired,
  setSelectedItems: PropTypes.func.isRequired,
};

export default CheckboxCards;
